import CheckoutError from './CheckoutError.js'

export default class CreateOrderCheckoutError extends CheckoutError {}
